import { Alert, Button, Snackbar } from "@mui/material";
import { useChatNotifications } from "./useChatNotifications";

/**
 * The soft-ask. Shown on return to a tab where a chat finished unseen, never on
 * mount — see useChatNotifications for why the offer waits for focus, and
 * chatNotifications for why we never call requestPermission() unprompted.
 */
export function ChatNotificationPrompt() {
  const { offering, accept, decline } = useChatNotifications();

  return (
    <Snackbar
      open={offering}
      onClose={decline}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        severity="info"
        onClose={decline}
        action={
          <>
            <Button
              size="small"
              onClick={decline}
              data-cy="chat-notify-decline"
            >
              Not now
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={accept}
              data-cy="chat-notify-accept"
            >
              Notify me
            </Button>
          </>
        }
      >
        Your chat finished while you were away.
      </Alert>
    </Snackbar>
  );
}
